import { authenticatedApi } from '../../../shared/api/apiClientUtils';

// Request types
export interface SoleTraderDetailsRequest {
  hmrcFullName?: string;
  utr?: string;
  nationalInsuranceNumber?: string;
}

export interface LimitedCompanyDetailsRequest {
  companyName?: string;
  utr?: string;
  companyRegistrationNumber?: string;
}

export interface UpsertBusinessDetailsRequest {
  isBookingWork: boolean;
  businessName?: string;
  soleTrader?: SoleTraderDetailsRequest;
  limitedCompany?: LimitedCompanyDetailsRequest;
}

// Response types
export interface SoleTraderDetailsResponse {
  hmrcFullName?: string;
  utr?: string;
  nationalInsuranceNumber?: string;
}

export interface LimitedCompanyDetailsResponse {
  companyName?: string;
  utr?: string;
  companyRegistrationNumber?: string;
}

export interface BusinessDetailsResponse {
  isBookingWork: boolean;
  businessName?: string;
  soleTrader?: SoleTraderDetailsResponse;
  limitedCompany?: LimitedCompanyDetailsResponse;
  isComplete: boolean;
}

/**
 * Get the current user's business details
 */
export const getBusinessDetails = async (): Promise<
  BusinessDetailsResponse | undefined
> => {
  const response = await authenticatedApi.get<BusinessDetailsResponse>(
    '/api/v1/users/me/business-details'
  );

  if (response.status === 204) {
    return undefined;
  }

  return response.data;
};

/**
 * Create or update the current user's business details
 */
export const upsertBusinessDetails = async (
  request: UpsertBusinessDetailsRequest
): Promise<BusinessDetailsResponse> => {
  const response = await authenticatedApi.put<BusinessDetailsResponse>(
    '/api/v1/users/me/business-details',
    request
  );

  return response.data;
};
